export default __webpack_public_path__ + "media/zurb/img/ecommerce/tmw_landing-ff98d6b5b038c1c665303a958d79f12f.png";